export default "__VITE_ASSET__Cjlg9gZU__"